import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,[_vm._v("Set App Users For Cars")]),_c(VCardText,[_c('AppUserSelect',{attrs:{"label":"App Users","small-chips":"","deletable-chips":"","multiple":"","clearable":""},model:{value:(_vm.appUsers),callback:function ($$v) {_vm.appUsers=$$v},expression:"appUsers"}})],1),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"primary","loading":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }